module.exports = __webpack_public_path__ + "img/gsb53.b8abc280.png";